import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useProviderSettings } from '../../hooks/useProviderSettings';

const PRIVATE = ['/dashboard', '/admin', '/partner/', '/book-appointment', '/video', '/consultation', '/sign', '/profile', '/my-documents', '/availability', '/feedback', '/nachweis', '/login', '/register', '/forgot-password', '/reset-password'];

// noindex für private Bereiche + Verifizierungs-Codes (Google/Bing) aus den Admin-Einstellungen
export const SeoMeta = () => {
  const { pathname } = useLocation();
  const s = useProviderSettings();
  const isPrivate = pathname === '/partner' || PRIVATE.some((p) => pathname.startsWith(p));
  return (
    <Helmet>
      {isPrivate && <meta name="robots" content="noindex, nofollow" />}
      {s?.google_site_verification && <meta name="google-site-verification" content={s.google_site_verification} />}
      {s?.bing_site_verification && <meta name="msvalidate.01" content={s.bing_site_verification} />}
    </Helmet>
  );
};
